<div class="dialog-container">
  <div class="dialog-header">
    <h2>Notifications (Last 7 Days)</h2>
    <div class="header-actions">
      <span
        class="clear-btn"
        (click)="clearAll()"
        *ngIf="notifications.length > 0"
        >Clear All</span
      >
      <span class="close-btn material-icons" (click)="close()">close</span>
    </div>
  </div>

  <div class="notification-list">
    <div
      *ngFor="let note of notifications"
      class="notification-item"
      [class.unread]="!note.isRead"
      (click)="handleNotificationClick(note)"
    >
      <div class="note-icon">
        <span class="material-icons" [ngClass]="note.type">
          {{
            note.type === "success"
              ? "check_circle"
              : note.type === "error"
                ? "error"
                : note.type === "warning"
                  ? "warning"
                  : "info"
          }}
        </span>
      </div>
      <div class="note-content">
        <h4>{{ note.title }}</h4>
        <p>{{ note.message }}</p>
        <span class="note-time">{{
          note.createdAt?.toDate() | date: "medium"
        }}</span>
      </div>
    </div>

    <div class="empty-state" *ngIf="notifications.length === 0">
      <img
        src="assets/images/no-notifications.svg"
        alt=""
        onerror="this.style.display = 'none'"
      />
      <p>No notifications in the last week.</p>
    </div>
  </div>
</div>
